

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../../assets/scss/LoginComponent.module.scss';
import Logo from '../../assets/images/cropLogo.png';
import { toast } from 'react-toastify';


const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

 const handleResetPassword = async () => {
  const passwordRegex = /^(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{10,}$/;
  let hasError = false;

  if (!password.trim()) {
    setPasswordError('Password is required');
    hasError = true;
  } else if (!passwordRegex.test(password)) {
    setPasswordError('Password must be at least 10 characters and include one special character');
    hasError = true;
  } else {
    setPasswordError('');
  }

  if (!confirmPassword.trim()) {
    setConfirmPasswordError('Confirm password is required');
    hasError = true;
  } else if (confirmPassword !== password) {
    setConfirmPasswordError('Passwords do not match');
    hasError = true;
  } else {
    setConfirmPasswordError('');
  }

  if (!hasError) {
    try {
      const res = await fetch(`https://devadmin.cropwork.in/user/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'resetToken': token,
        },
        body: JSON.stringify({
          newPassword: password,
          confirmPassword: confirmPassword,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success('Password reset successful!');
        navigate('/'); 
      } else {
        toast.error(data.message || 'Something went wrong');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong. Please try again.');
    }
  }
};


  return (
    <div className={styles.loginContainer}>
      <div className={styles.logo}>
        <img src={Logo} alt="Logo" />
      </div>
      <h2 className={styles.heading}>Reset your password</h2>

      <input
        type="password"
        placeholder="New Password"
        className={styles.inputField}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {passwordError && <div className={styles.errorsMsg}>{passwordError}</div>}

      <input
        type="password"
        placeholder="Confirm Password"
        className={styles.inputField}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      {confirmPasswordError && <div className={styles.errorsMsg}>{confirmPasswordError}</div>}

      <div className={styles.sendBtnContainer}>
        <button className={styles.sendBtn} onClick={handleResetPassword}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;

